import { render, staticRenderFns } from "./AssessmentGlobalTaskModal.vue?vue&type=template&id=4c1594d5&"
import script from "./AssessmentGlobalTaskModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports